<div class="container mx-lg-0">
  <div class="container d-flex flex-column d-lg-block">
      <div class="line-title mt-2vw py-2 justify-content-center d-flex d-lg-none" [ngClass]="infoProject?.actualState == 'fixed' ? 'bg-primary-card' : 'bg-secondary-card'">
            <p [ngClass]="infoProject?.dev?.company.length > 15 ? 'fs-14' : 'fs-16'" class="text-start w-100 ps-6 pe-2 cl-white">Proyecto de: {{ infoProject?.dev?.company }}</p>
      </div>
      <div class="d-flex d-lg-none overlay-circle" [ngClass]="infoProject?.actualState == 'fixed' ? 'bg-white' : 'bg-secondary-card'">
        <img *ngIf="imageLoaded && infoProject?.dev?.logo"
        class="circle-img"
        [src]="infoProject?.dev?.logo"
        alt="development-logo"
        (error)="imageLoaded = false">
      </div>
      <div class="div-photos position-relative d-block d-lg-none">
          <div class="image">
              <img [src]="buildGalleryImageUrl(imagesCarrusel?.[0])" alt="project-view">
          </div>
          <button class="btn button-photos position-absolute cl-black fw-sbold px-4" (click)="lightbox.open(1, 'lightbox')">Ver imágenes</button>
      </div>
      <div class="col-12 div-title position-relative">
          <div class="d-flex align-items-center mb-2">
            <h1 class="mb-0 name cl-black fw-sbold">{{formatName(infoProject?.name) }}</h1>
            @if(isReferralInternal) {
              <div class="cr-pointer ms-3 position-relative">
                <img (click)="changeStateToastShare()" src="assets/icons/share-icon.svg" width="25px"  alt="#">
                <div class="share-toast" [ngClass]="showShareToast ? 'd-block' : 'd-none'">
                  <span class="toast-arrow"></span>
                  <div (click)="changeStateToastShare()" class="d-flex justify-content-end align-items-center mb-2">
                    <a class="ms-1"><img class="filter-black" src="/assets/icon/x.svg" alt="x"></a>
                  </div>
                  <div class="d-flex justify-content-end align-items-center mb-2">
                    <p class="fs-11 cl-black lh-base">Comparte este link a tu base de inversionistas, para que te sea asignada la venta. Tu inversionista tendrá acceso a la vista de este proyecto y formará parte de tus referidos.</p>
                  </div>
                  @for (items of shareToastItems; track $index) {
                    <div class="d-flex justify-content-start align-items-center mb-2">
                      @if(items.onClick) {
                        <button
                        class="website fw-sbold btn-link-style"
                        [ngClass]="items.class"
                        (click)="items.onClick()"
                        >
                          <img class="me-2" [src]="items.icon" [alt]="items.alt">{{ items.name }}
                        </button>
                      }
                      @if(!items.onClick) {
                        <a
                        class="website fw-sbold m-auto text-center"
                        [ngClass]="items.class"
                        [href]="items.url"
                        target="_blank"
                      >
                        <img class="me-2" [src]="items.icon" [alt]="items.alt">{{ items.name }}
                      </a>
                      }
                    </div>
                  }
                  
                </div>
              </div>
            }
          </div>
          <div class="d-lg-flex align-items-center city d-none mt-1">
            <img class="me-2" src="/assets/img/icon/location-icon.svg" alt="location-icon">
            <h6 class="city cl-black fw-regular d-none d-lg-block m-0">{{ infoProject?.city?.name }}</h6>
          </div>
          <div class="div-city d-flex align-items-start d-block d-lg-none">
              <img class="me-2 mt-060" src="/assets/img/icon/location-icon.svg" alt="location-icon">
              <h6 class="city mt-2 cl-black fw-regular">{{ infoProject?.city?.name }}</h6>
          </div>
          <h6 class="stage cl-black fw-regular mt-lg-3 mt-2">
            <img width="14" class="me-1 mb-1" src="../../../../../../assets/icons/campaign-icon.svg" alt="campaign-icon">
            {{ infoProject?.actualState == 'variable' && infoProject?.name?.includes('Casa') ? 'Casa:' : 'Campaña:'}}
            <span [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card fw-bold' : 'cl-secondary-card fw-bold'">{{ stepProject }}</span>
          </h6>
      </div>
      <!-- <div class="col-12 div-carousel d-none d-lg-block">
            <div class="swiper-images-container">
              <swiper [config]="carouselConfig">
                  @for(img of imagesCarrusel; track $index) {
                    <ng-template swiperSlide>
                      <div class="container-img">
                        <img [src]="urlBaseS3 + infoProject?.pid + '/' + img" alt="Swiper-image-per-pid">
                      </div>
                    </ng-template>
                  }
              </swiper>
            </div>
      </div> -->
      <div class="d-none d-lg-flex overlay-circle bg-white">
        <img *ngIf="imageLoaded && infoProject?.dev?.logo"
        class="circle-img"
        [src]="infoProject?.dev?.logo || infoProject?.dev?.logoDevelopment"
        alt="development-logo"
        (error)="imageLoaded = false">
      </div>
      <div class="col-12 position-relative image-container d-none d-lg-block">
        <div class="background-image">
            <img class="img-bg" [src]="buildGalleryImageUrl(imagesCarrusel?.[0])" alt="project-view">
            <div class="overlay-rectangle" [ngClass]="infoProject?.actualState == 'fixed' ? 'bg-primary-card' : 'bg-secondary-card'">
                <span [ngClass]="infoProject?.dev?.company.length > 15 ? 'fs-14' : 'fs-20'" class="ps-7 cl-white text-start fw-sbold w-100 pe-lg-2 pe-xl-0">Proyecto de: {{ infoProject?.dev?.company }}</span>
            </div>
        </div>
        <button class="btn button-photos position-absolute cl-black fw-sbold px-4" (click)="lightbox.open(0, 'lightbox')">Ver imágenes</button>
    </div>
      <div class="col-12 div-buttons">
          <div class="d-flex">
              <div class="first-info text-center text-sm-start pill-info d-flex justify-content-center align-items-center py-1 px-3" [ngClass]="infoProject?.actualState == 'fixed' ? 'bg-primary-card' : 'bg-secondary-card'">
                <p class="m-0">
                  {{ getProjectStateText(infoProject?.state) }}
               </p>
              </div>
              <div class="second-info pill-info text-center d-flex justify-content-center align-items-center py-1 px-2"><p class="fw-sbold">{{ infoProject?.newProject?.sectionInformation?.typeProperty || 'Inmueble mixto'}}</div>
          </div>
      </div>
      <div class="col-12 d-block d-lg-none mt-4 div-card-achoraded">
        <div class="card-achoraded py-2">
         <div [innerHTML]="labelFreeParts | safeHtml"></div>
         <div class="card-achoraded mt-2">
            <div class="progress-container">
              <div class="bg-line">
                <div class="bg-process" [style.width.%]="percentage">
                  <div class="message fw-sbold text-center" [style.right.px]="rightPosition()"><span [style.transform]="getSpanTranslate()"></span>{{ message }}</div>
                </div>
              </div>
            </div>
          </div>
          <div><p class="py-sm-2 pt-2 pb-0 cl-primary-2 fw-bold">Monto fondeado: <span [countUp]="( phase?.active * 1000 ) | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></span></p></div>
          <div class="d-flex justify-content-between mt-3 mt-sm-0 part-number fs-14" *ngIf="phase?.free !== 0">
              <p class="fs-14">Mínimo: <strong class="cl-blue-2" [countUp]="( phase?.minAmountProject * 1000 ) | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></strong></p>
              <p class="fs-14">Máximo: <strong [countUp]="( phase?.total * 1000 ) | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></strong></p>
          </div>
      </div>
      </div>
  </div>
</div>
